import useDynamicPage from "@/hooks/useDynamicPage";
import useDynamicPages from "@/hooks/useDynamicPages";
import { DynamicPageSeo } from "@/ui/DynamicPageSeo";
import { useRouter } from "next/router";
import { BuilderContentBlocks } from "@/ui/BuilderContentBlocks";
import { PoweredByBannerOffset } from "@/components/PoweredByBanner";

export default function GenericPages({ prefix, title, seo, canonical, data }) {
  const router = useRouter();
  const isGskPlacementsPage = router.asPath === "/gsk-summer-placements";
  // The US homepage shows the PoweredByBanner in the header (see MainHeader).
  const isUsHomepage = canonical === "/us";

  return (
    <>
      <DynamicPageSeo
        {...seo}
        title={seo?.title.length > 0 ? seo.title : title}
        canonical={seo?.canonical.length > 0 ? seo.canonical : canonical}
      />
      {isUsHomepage && <PoweredByBannerOffset />}
      <BuilderContentBlocks data={data} prefix={prefix} />

      {isGskPlacementsPage && (
        <iframe
          src="https://bot.leadoo.com/bot/inpage.html?code=w70q18a6bmbmr39i"
          style={{ border: "none" }}
          width="100%"
          height="450px"
        />
      )}
    </>
  );
}

export async function getStaticProps({ params: { url_slugs } }) {
  const url_slug = url_slugs.join("/");
  const page = useDynamicPage(url_slug);

  if (page?.is_draft === true) {
    return { notFound: true };
  }

  return {
    props: {
      isBuilder: true,
      locale: url_slug === "us" || url_slug.startsWith("us/") ? "us" : "en",
      prefix: `page_${url_slug.replaceAll(/[\/\-]/g, "_")}`,
      title: page.title,
      seo: page.seo,
      canonical: `/${url_slug}`,
      data: page.content,
    },
  };
}

export async function getStaticPaths() {
  const pages = useDynamicPages();
  const exclude = ["/"];

  const paths = pages
    .filter(
      (page) =>
        !page?.is_draft === true &&
        !exclude.includes(page.url_slug)
    )
    .map((i) => ({ params: { url_slugs: i.url_slug.split("/") } }));

  return {
    paths,
    fallback: false,
  };
}
